import React from "react";
import Table from "../components/Billing/Table";
import Header from "../components/Header";
import Dotted from "../../assets/svgs/Dotted";

function BillingHeaderItem({ amount, text }) {
  return (
    <div className="flex flex-col bg-gray-50 shadow-xl px-2 lg:px-4 py-2">
      <div className="flex justify-between space-x-3 lg:space-x-9 items-start">
        <h2 className="text-base lg:text-2xl">{amount}</h2>
        <button className="text-gray-500">
          <Dotted />
        </button>
      </div>
      <p className="font-medium w-full text-left text-xs lg:text-sm">{text}</p>
    </div>
  );
}

const Billing = ({ LeftNavRef }) => {
  return (
    <div className="w-full px-4 md:px-10 pb-10">
      <Header LeftNavRef={LeftNavRef} />
      <div className="my-6 flex justify-between px-6 space-x-6 lg:px-0 lg:space-x-0 items-center max-w-full overflow-x-auto">
        <h3 className="text-lg">Billing</h3>
        <BillingHeaderItem amount="€50,485,00" text="Paid This Month" />
        <BillingHeaderItem amount="€50,485,00" text="Paid This Month" />
        <BillingHeaderItem amount="€34,485,00" text="Due" />
        <BillingHeaderItem amount="€34,485,00" text="Overdue" />
      </div>
      <Table />
    </div>
  );
};

export default Billing;
